module.exports = require("@splunk/dashboard-visualizations/SingleValue");